import { IdHelper } from '@src/core/helpers';
import { Analytics, getAnalytics, logEvent } from 'firebase/analytics';
import { firebaseApp } from '../firebase/firebase.client';

// Analytics
let analytics: Analytics;
if (process.env.REACT_APP_USE_EMULATOR !== 'true') {
  analytics = getAnalytics(firebaseApp);
}

class FirebaseAnalyticsClient {
  static collectPageView(collectNumber: number, contactId: number): void {
    if (process.env.REACT_APP_USE_EMULATOR === 'true') return;
    logEvent(analytics, 'page_view', {
      page_title: `Coleta ${IdHelper.formatCollectId(collectNumber)}`,
      contact_id: IdHelper.formatContactId(contactId),
    });
  }

  static formsLogin(contactId: number): void {
    if (process.env.REACT_APP_USE_EMULATOR === 'true') return;
    logEvent(analytics, 'login', {
      method: 'token',
      contact_id: IdHelper.formatContactId(contactId),
    });
  }

  static appLogin(userName: string): void {
    if (process.env.REACT_APP_USE_EMULATOR === 'true') return;
    logEvent(analytics, 'login', {
      method: 'auth',
      username: userName,
    });
  }

  static validateLogin(userName: string): void {
    if (process.env.REACT_APP_USE_EMULATOR === 'true') return;
    logEvent(analytics, 'validate_login', {
      username: userName,
    });
  }
}

export { FirebaseAnalyticsClient };
